<template>
  <button
    type="button"
    class="rounded border border-gray-300 bg-white px-2 py-0.5 text-xs font-medium normal-case text-gray-700 hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50"
    :disabled="disabled"
    data-cy="map-next-sample"
  >
    Next sample
  </button>
</template>

<script setup lang="ts">
defineProps<{ disabled: boolean }>();
</script>
